import { render, staticRenderFns } from "./text-area-group.vue?vue&type=template&id=c53a7ddc&"
import script from "./text-area-group.vue?vue&type=script&lang=js&"
export * from "./text-area-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports